<template>
  <div class="topic-assistant-page">
    <TopicAssistant
      v-if="selectedTool"
      :greetingMsg="selectedTool.label"
      :curInfoToolTipMsg="selectedTool.intro"
      :conversationId="conversationId"
      :toolIdx="toolIdx"
      :toolList="toolList"
      @close_tool="goToAcademicSearch"
    />
  </div>
</template>

<script>
/* eslint-disable */
import TopicAssistant from "../components/TopicAssistant.vue";
import { findLeftBarRef } from "../utils/leftBarRef";

export default {
  name: "TopicAssistantHomePage",
  components: {
    TopicAssistant,
  },
  data() {
    return {
      conversationId: null,
      toolIdx: null,
      toolList: [],
    };
  },
  computed: {
    selectedTool() {
      if (this.toolIdx == null || !Array.isArray(this.toolList) || !this.toolList[this.toolIdx]) {
        return null;
      }
      return this.toolList[this.toolIdx];
    },
  },
  mounted() {
    this.initPage();
  },
  activated() {
    this.initPage();
  },
  methods: {
    async initPage() {
      await this.ensureToolContext();
      await this.ensureConversationId();
    },
    async ensureToolContext() {
      const savedBackContext = sessionStorage.getItem("topic_assistant_back_context");
      if (savedBackContext) {
        try {
          const { tool_idx, tool_list } = JSON.parse(savedBackContext);
          if (Array.isArray(tool_list) && tool_idx != null && tool_list[tool_idx]) {
            this.toolList = tool_list;
            this.toolIdx = tool_idx;
            return;
          }
        } catch (error) {}
      }

      const leftBarRef = findLeftBarRef(this);
      if (leftBarRef && Array.isArray(leftBarRef.tool_list) && leftBarRef.tool_list.length > 0) {
        const idx = leftBarRef.tool_list.findIndex(tool => tool && tool.function === "topic_selection_assistance");
        if (idx !== -1) {
          this.toolList = leftBarRef.tool_list;
          this.toolIdx = idx;
          return;
        }
      }

      const res = await this.$http.get(this.globalUrl.tool_list);
      const list = Array.isArray(res.data) ? res.data : [];
      const idx = list.findIndex(tool => tool && tool.function === "topic_selection_assistance");
      this.toolList = list;
      this.toolIdx = idx !== -1 ? idx : null;
    },
    async ensureConversationId() {
      const savedBackContext = sessionStorage.getItem("topic_assistant_back_context");
      if (savedBackContext) {
        try {
          const { conversation_id } = JSON.parse(savedBackContext);
          if (conversation_id) {
            this.conversationId = conversation_id;
            return;
          }
        } catch (error) {}
      }

      if (this.conversationId) {
        return;
      }

      const res = await this.$http.get(this.globalUrl.cxai_conversation_add);
      this.conversationId = res.data;
    },
    goToAcademicSearch() {
      this.$router.push({ path: "/ai_home" }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.topic-assistant-page {
  height: 100vh;
  width: 100%;
  overflow: auto;
  background: linear-gradient(rgb(255, 255, 255) 0%, rgb(232, 240, 254, 0.5) 100%);
}
</style>
